import request from "@/axios/http";


// 前端上传文件（onProgress 可选，用于上传进度回调）
export function upLoadFile (params, data, onProgress) {
	// 若传入的是普通对象，统一包装成标准 multipart FormData，
	// 否则 axios 会把对象序列化成 JSON 发出，后端会报 "Current request is not a multipart request"
	let postData = data;
	if (!(typeof FormData !== 'undefined' && data instanceof FormData)) {
		postData = new FormData();
		for (const key in data) {
			if (Object.prototype.hasOwnProperty.call(data, key)) {
				postData.append(key, data[key]);
			}
		}
	}
	return request({
		url: '/stage-api/commonFile/upLoadFile' + params,
		method: 'post',
		data: postData,
		timeout:-1,
		onUploadProgress: onProgress
	})
}

// 返回前端主键id 前端上传文件用 
export function queryUuIdInfo () {
	return request({
		url: '/stage-api/commonFile/queryUuIdInfo',
		method: 'post',
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}

// 字典
export function queryDictionary (params) {
	return request({
		url: '/stage-api/system/dict/data/type/' + params,
		method: 'get',
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}

// 字典
export function queryLotteryType () {
	return request({
		url: '/stage-api/pre/dict/lottery-type',
		method: 'get',
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}

// 附件下载
export function downLoadFile (params) {
	return request({
		url: '/stage-api/commonFile/downLoadFile',
		method: 'get',
		headers: { 'Content-Type': 'multipart/form-data' },
		params,
	})
}


export function getInfo (data) {
	return request({
		url: '/stage-api/getUserInfo',
		method: 'get',
		data
	})
}


// 商品统一创建订单接口
export function createOrder (data) {
	return request({
		url: '/stage-api/order/v2/createOrder',
		method: 'post',
		data
	})
}

// 查询友情链接列表
export function linkList (params) {
	return request({
		url: '/stage-api/anonymous/link/list',
		method: 'get',
		params
	})
}
